import {
  IFieldWithTranslation,
} from 'src/components/profileComponents/Marketplace/types';
import { IMarketplaceLanguageObjects } from 'src/typings/marketplace';

export const isNeedToBeUpdated = ((systemName: string | undefined, value: IFieldWithTranslation | null, props: IMarketplaceLanguageObjects): boolean => {
  if (!props || !Object.keys(props).length || !systemName) return false;
  return !!props[systemName]?.length && !props[systemName]
    .find((prop) => JSON.stringify(prop) === JSON.stringify(value));
});
